import { render, staticRenderFns } from "./IncidentForm.vue?vue&type=template&id=6e8a2310&"
import script from "./IncidentForm.vue?vue&type=script&lang=js&"
export * from "./IncidentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports